import { SITE_PAGES } from '../../../lib/constants'
import Select from '../../ui/Select'

interface PageSelectorProps {
  value: string
  onChange: (value: string) => void
  label?: string
  required?: boolean
  error?: string
}

/**
 * Dropdown de sélection de page pour le formulaire de ticket
 * Format de la valeur : "Page Name|/path|label"
 */
function PageSelector({ value, onChange, label = 'Page concernée', required = false, error }: PageSelectorProps) {
  return (
    <Select
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      error={error}
    >
      <option value="">-- Sélectionnez une page --</option>
      {SITE_PAGES.map((page, index) => {
        // Format : "Page Name|/path|label"
        const optionValue = `${page.name}|${page.path}|${page.label}`

        return (
          <option key={index} value={optionValue}>
            {page.name}
          </option>
        )
      })}
    </Select>
  )
}

export default PageSelector
